import React, { useRef } from 'react';
import { TitCiclo, Rotulo, DiadoMes } from '../../components/Ciclo/styles';
import { Main } from './styles';
import Header from '../../components/Header';
import { GlobalStyle } from '../../styles/global';
import { useLocation } from "react-router-dom";
import { Simbols } from '../../components/Simbols';
import { format, parseISO } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';
import logo from '../../assets/metodo-billings-marca-dashboard.png';
import { useReactToPrint } from 'react-to-print'


const GeraImpresso: React.FC = () => {

  const location = useLocation();
  const ref = useRef(null);  
  const dadosciclo = location.state.dadosciclo;

  const handlePrint = useReactToPrint({
    pageStyle : "@page { size: auto;  margin: 12mm 8mm; font-size: 0 } @media print { body { -webkit-print-color-adjust: exact; } }",
    content: () => ref.current,
    
  });


  return (
    <>
        <Header />
        <Main>


          <div className="page spaceInfo">

            <button onClick={handlePrint}>CLIQUE PARA IMPRIMIR OU SALVAR PDF</button>
            <div>
            PDF: Caso deseje salvar em pdf, clique no botão ao lado e nas opções de destino escolha salvar em pdf.
            </div>
          </div>


          <div className="page" ref={ref}>

          
          <table style={{width: '100%', padding: '0'}}>
                    <thead>
                      <tr>
                        <th style={{textAlign: 'left'}} colSpan={2}><img className="logo" src={logo} alt="Métoto Billings" /></th>
                        <th style={{textAlign: 'right'}} colSpan={7}>
                        <TitCiclo antigo={false}><h2>{location.state.cicloatual ? 'Ciclo Atual' : location.state.posicaociclo + 'º Ciclo'}</h2>
                        <div style={{textTransform: 'uppercase', fontWeight: 100, marginTop: 5, fontSize: 12}}>início: {location.state.dadosciclo.length > 0 && format(parseISO(dadosciclo[0]['dia']), "dd 'de' MMM 'de' yyy", { locale: ptBR}) }</div>
                        <br></br>
                        </TitCiclo>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={{height: 60}}></td>
                            <td style={{width: '70%'}}></td>
                            <td><Rotulo>Dias</Rotulo></td>
                            <td><Rotulo>Símbolo</Rotulo></td>
                            <td><Rotulo>Fertilidade</Rotulo></td>
                            <td><Rotulo>Relação</Rotulo></td>
                            <td><Rotulo>Regra</Rotulo></td>
                        </tr>
                        {dadosciclo.map((e: any, i: number) => 
                            <tr key={i+e.numciclo} style={{}}>
                                <td style={{borderBottom: 'solid 1px rgba(0,0,0,0.1)', borderRight: 'solid 1px rgba(0,0,0,0.05)', minWidth: 20, textAlign: 'center', color: '#4BAFA7'}}>{i}</td>
                                <td style={{borderBottom: 'solid 1px rgba(0,0,0,0.1)', borderRight: 'solid 1px rgba(0,0,0,0.05)', padding: 5}}>
                                    
                                  {e.sensacao !== null && <div style={{textTransform: 'uppercase', fontWeight: 'bold'}}>{e.descsensacao}</div> }
                                  {e.obssensacao && <small style={{display: 'block'}}>{e.obssensacao}</small> }
                              
                                </td>
                                <td style={{borderBottom: 'solid 1px rgba(0,0,0,0.1)', borderRight: 'solid 1px rgba(0,0,0,0.05)'}}><DiadoMes><span>{format(parseISO(e.dia), "dd")}</span><small>{format(parseISO(e.dia), "MMM", {locale: ptBR})}</small></DiadoMes></td>
                                <td style={{borderBottom: 'solid 1px rgba(0,0,0,0.1)', borderRight: 'solid 1px rgba(0,0,0,0.05)'}}>
                                  {e.id_mob && 
                                    <>
                                    <Simbols edit={false} comp='simbol' regra={e.regra} /> 
                                    <Simbols edit={false} comp='selo' regra={e.selo} />
                                    </> }
                                </td>
                                <td style={{borderBottom: 'solid 1px rgba(0,0,0,0.1)', borderRight: 'solid 1px rgba(0,0,0,0.05)'}}>{e.id_mob && <Simbols edit={false} comp='fertilidade' regra={e.fertilidade}  /> }</td>
                                <td style={{borderBottom: 'solid 1px rgba(0,0,0,0.1)', borderRight: 'solid 1px rgba(0,0,0,0.05)'}}>{e.id_mob && <Simbols edit={false} comp='relacao' regra={e.relacao}  /> }</td>
                                <td style={{borderBottom: 'solid 1px rgba(0,0,0,0.1)'}}>
                                  {e.id_mob && <Simbols edit={false} comp='regradia' regra={e.regradia}  /> }
                                </td>
                            </tr>
                                               
                        )}                                              
                    </tbody>
                </table>
              <br></br>
          </div>
        </Main>
        <GlobalStyle />
    </>
   );
}

export default GeraImpresso;